import { render } from "./ProductReviews.vue?vue&type=template&id=e274db8a"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__